import { render } from "./SelectButton.vue?vue&type=template&id=16228afe&scoped=true"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=16228afe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16228afe"]])

export default __exports__